module.exports = __webpack_public_path__ + "static/thumb-aa10ec02911414c4203b8bb26925890b.png";